module.exports = __webpack_public_path__ + "img/placeholder.c9945169.jpg";